import { MFButton } from "../../../../common/components/MFButton";
import { MFCheckbox } from "../../../../common/components/MFCheckbox";
import MFModal from "../../../../common/containers/MFModal";

export function ModalDelArchCalculs({
  isOpen,
  onClose,
  onValidate,
  dontShowDelArchCalculsModal,
  setDontShowDelArchCalculsModal,
}) {
  return (
    <MFModal
      isOpen={isOpen}
      onClose={onClose}
      dialogClassName="calculs-not-duplicable"
    >
      <p className="modal-text" style={{ marginBottom: "20px" }}>
        Les calculs que vous souhaitez supprimer/archiver ne sont pas tous de la
        même nature. Les calculs “en cours” seront supprimés définitivement,
        tandis que les calculs “finalisés” seront archivés (vous pourrez les
        retrouver dans le dossier “Archives” et les restaurer si besoin).
      </p>
      <div className="d-flex flex-column">
        <MFCheckbox
          checked={dontShowDelArchCalculsModal}
          onChange={(e) => setDontShowDelArchCalculsModal(e.target.checked)}
          label="Ne plus afficher ce message"
        />
      </div>
      <div className="d-flex align-items-center justify-content-end mt-2">
        <MFButton
          className="mr-1"
          style={{ fontSize: 15 }}
          cancelButton
          onClick={onClose}
        >
          Annuler
        </MFButton>
        <MFButton style={{ fontSize: 15 }} onClick={onValidate}>
          Valider
        </MFButton>
      </div>
    </MFModal>
  );
}
